window._ = require('lodash');

window.toastr = require('toastr');

import flatpickr from 'flatpickr';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import FlatpickrLanguages from "flatpickr/dist/l10n";
flatpickr.localize(FlatpickrLanguages['hr'])

try {
    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

window.initializeFlatpickr = function() {
    $('.flatpickr').flatpickr({
        dateFormat: "d.m.Y",
        allowInput: true,
        locale: {
            firstDayOfWeek: 1
        }
    });
}

window.initializeFlatpickrMonthPicker = function(selector = '.flatpickrMonthPicker', callback = null) {
    const input = document.querySelector(selector);
    if (!input) return;

    const month = parseInt(input.dataset.month);
    const year = parseInt(input.dataset.year);
    const defaultDate = new Date(year, month - 1);

    flatpickr(selector, {
        plugins: [new monthSelectPlugin({
            shorthand: false,
            dateFormat: "F Y",
            altFormat: "F Y",
            theme: "light"
        })],
        defaultDate: defaultDate,
        locale: 'hr',
        onChange: function (selectedDates) {
            if (typeof callback === 'function' && selectedDates.length) {
                callback(selectedDates[0]);
            }
        }
    });

    // Prikaži labelu (npr. "Veljača 2024")
    const options = { year: 'numeric', month: 'long' };
    const label = defaultDate.toLocaleDateString('hr-HR', options);
    input.value = label.charAt(0).toUpperCase() + label.slice(1);
}



window.initializeSelect2 = function(id, placeholderText, dropdownParent, minimumResultsForSearch = 0, allowClear = false) {

    $(`[id="${id}"]`).select2({
        dropdownParent: dropdownParent,
        width: '100%',
        theme: 'bootstrap4',
        minimumResultsForSearch: minimumResultsForSearch, // vrijednost -1 makne search box
        placeholder: placeholderText,
        allowClear: allowClear
    });
}

initializeFlatpickr();

window.generateDatatable = function(settings, tableSelector) {
    // Pushing additional settings
    settings.lengthMenu = [[10, 25, 50, 100, -1], [10, 25, 50, 100, 'Svi']];
    settings.pageLength = 10;
    settings.pagingType = 'simple_numbers';
    settings.dom = '<"row pb-3"<"col-5"l><"col-3"f><"col-4 text-right"B>>rt<"row "pi>';
    settings.initComplete = function(settings, json) {
        $(this.api().table().container()).find('.btn-group').removeClass('btn-group');

        // Search input
        var filterInput = $(this.api().table().container()).find('input[type=search]');
        filterInput.addClass('dt-search-filter');
        filterInput.attr('placeholder', 'Pretraži:');
        filterInput.parent().append('<img class="search-icon" src="/images/search.png">');

        // Find the closest '.ft-pagination' container relative to the current table
        var ftPagination = $(this.api().table().container()).parents('.page-tab').find('.ft-pagination');

        $(this.api().table().container()).find('.dataTables_paginate').prependTo(ftPagination);
        $(this.api().table().container()).find('.dataTables_info').prependTo(ftPagination.find('span'));
    };

    // Call DataTables with the settings
    return tableSelector.DataTable(settings);
}

window.hexToRgba = function(hex, alpha) {
    // Remove the # if present
    hex = hex.replace('#', '');

    // Expand shorthand form (#abc → #aabbcc)
    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    // Convert to RGB
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

window.stringToHexColor = function(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xFF;
        color += ('00' + value.toString(16)).slice(-2);
    }
    return color;
}

// Svakom flatpickru dodaj ikonu kalendara na kraj placehodera
$('.set-cal-icon:not(.alt-icon)').after('<img class="calendar-icon" src="/images/calendar.png">');
// Alternativno dodavanje s dodatnom klasom
$('.set-cal-icon.alt-icon').after('<img class="calendar-icon calendar-icon--alt" src="/images/calendar.png">');